import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "product-filtering__results" }
const _hoisted_2 = { class: "product-card-grid__results" }
const _hoisted_3 = {
  key: 1,
  class: "col-12 mb-5 text-center p-3 bg-gray-light"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "load-more mt-5" }
const _hoisted_6 = { class: "load-more__text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ProductCard = _resolveComponent("ProductCard")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString($setup.store.getters?.totalProducts) + " " + _toDisplayString($props.translations.Products), 1 /* TEXT */),
    ($props.products.length)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: _normalizeClass(["product-card-grid", $setup.store.state?.filtersVisible ? 'product-card-grid--3-up' : 'product-card-grid--4-up'])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.products, (product, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "product-card-grid__item",
              key: index
            }, [
              _createVNode(_component_ProductCard, {
                url: product.productDetailUrl,
                title: product.displayName,
                imageUrl: product.primaryImageUrl,
                numberOfFinishes: product.alternateFinishes.length ? product.alternateFinishes.length : null,
                isFinishImageMissing: product.isFinishImageMissing,
                beautyImageUrl: product.beautyImageUrl,
                description: product.productBrowseDescription,
                availability: product.availability,
                modelNumber: product.modelNumber,
                index: index,
                translations: $props.translations,
                product: product,
                isDiscontinued: product.isDiscontinued
              }, null, 8 /* PROPS */, ["url", "title", "imageUrl", "numberOfFinishes", "isFinishImageMissing", "beautyImageUrl", "description", "availability", "modelNumber", "index", "translations", "product", "isDiscontinued"])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ], 2 /* CLASS */))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($props.translations.NoProductsAvailable) + ".", 1 /* TEXT */)),
    ($props.paging.pageNumber < $props.paging.totalPages)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "btn btn-outline-primary btn-lg load-more__btn",
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('loadMoreProducts')))
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString($props.translations.LoadMore), 1 /* TEXT */)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}